import { ErrorPage } from '@aspendental/shared-components-web';
import { GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import getConfigByBrand from './utils/get-config-by-brand';

import { AppConfigByAppNameDocument } from '@src/lib/__generated/sdk';
import { client, previewClient } from '@src/lib/client';
import { getServerSideTranslations } from '@src/pages/utils/get-serverside-translations';

const ErrorPage404 = () => {
	const router = useRouter();
	useEffect(() => {
		//TODO: Figure out the theme and environment name for 404 page
	}, [router.asPath]);
	return (
		<>
			<ErrorPage
				backgroundImageUrl="https://images.ctfassets.net/m8zwsu9tyucg/5fhlfO83zrA0Eh0c76nuPW/dab516d6d7acb1352edab3a526fe43fa/Hero_v2_Desktop.png?q=90&fit=fill&f=face&bg=rgb%3A321032&fm=webp"
				backgroundImageUrlMobile="https://images.ctfassets.net/m8zwsu9tyucg/12b9aOLC9Y5cmS2kw0N2ww/9ec2783a066ace40d63e639d7d326ab8/m.hero.png?q=90&fit=fill&f=face&bg=rgb%3A321032&fm=webp"
				body="Oops! Looks like you’ve read to the end of this chapter and need to turn back to the homepage."
				buttonLabel="Back to Homepage"
				heading="404"
				subtitle=""
				darkTextColor={true}
			/>
		</>
	);
};

export const getStaticProps: GetStaticProps = (async ({ locale, preview = false }) => {
	try {
		// Priority: HTTP header x-tag-theme > domain > process.env.TAG_BRAND_THEME
		const tagTheme = (process.env.TAG_BRAND_THEME || 'chapter') as TagThemeType;
		const brandConfig = getConfigByBrand(tagTheme);

		const gqlClient = preview ? await previewClient() : await client();
		const appName = brandConfig.contentfulAppId || process.env.TAG_APP_NAME || 'TAG_Commercial_Web_Sandbox';

		const appConfig = await gqlClient.query(AppConfigByAppNameDocument, { appName, preview }).toPromise();

		const appData = appConfig.data.appCollection?.items[0];
		// TODO: remove this when we have a better way to get runtime environment name for static pages
		// The following way of getting environment name is not reliable because it depends on the build time.
		// Most likely that staging environment would be recognized as production for the 404 pages.
		const env = { ENVIRONMENT_NAME: process.env.NODE_ENV === 'production' ? 'prod' : 'stage' };
		// replace [env] with environment name for locationBarFindOfficeUrl
		// TODO: create a brand variable context to replace those variables from CMS in future
		if (appData && appData.header?.locationBarFindOfficeUrl) {
			const brandSubdomain = env?.ENVIRONMENT_NAME !== 'prod' ? 'wwwstg' : 'www';
			appData.header.locationBarFindOfficeUrl = appData.header?.locationBarFindOfficeUrl?.replace(
				'[env]',
				brandSubdomain
			);
		}
		if (!appData) {
			throw new Error('App data not found');
		}
		return {
			props: {
				...(await getServerSideTranslations(locale)),
				env,
				config: brandConfig,
				preview,
				appData,
				footerData: appData?.footer,
			},
		};
	} catch {
		return {
			props: {
				...(await getServerSideTranslations(locale)),
				preview,
				appData: null,
				footerData: null,
			},
		};
	}
}) satisfies GetStaticProps;

export default ErrorPage404;
